import { StorageLocationType } from "@redotech/crdb-enums/fulfillment/storage-location-type";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const BinSearchResultSchema = z.object({
  storageLocationId: storageLocationIdFormat.schema,
  binName: z.string(),
  binType: createEnum(StorageLocationType),
  locationId: locationIdFormat.schema,
  locationName: z.string(),
  /**
   * Oldest last_counted_at across the bin's levels, or null when any of them
   * has never been counted — a never-counted level is older than any date.
   */
  lastCountedAt: z.date().nullable(),
});
export type BinSearchResult = z.infer<typeof BinSearchResultSchema>;

export const searchBins = {
  name: "searchBins" as const,
  input: z.object({
    productId: productIdFormat.schema.optional(),
    locationId: locationIdFormat.schema.optional(),
    search: z.string().optional(),
    /** Also match storage bins, for callers that can write to one. */
    includeStorageBins: z.boolean().nullish(),
    includeReceivingBins: z.boolean().nullish(),
  }),
  output: z.object({ bins: z.array(BinSearchResultSchema) }),
};
